import src from "IMAGE";
export default { src, width: 1891, height: 978, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQklEQVR42k2MOQoAMAgE7RQvtPL/Pw0rJKQYXEZdYuYRkblTVV8G5O4TEbsws82/o6qa7l6ZmQscgCMIfOL6b7nuAMJpByUAV/1dAAAAAElFTkSuQmCC"};
